import React from 'react'
import CheckValidIcon from '@Images/check_valid_icon.svg'
import CheckMutedIcon from '@Images/check_muted_icon.svg'

import {
  PASSWORD_MIN_LENGTH_SIGN_UP,
} from '@Utils/AuthenticationValidationHelpers'

import './SecurityChecklist.scss'

interface SecurityChecklistProps {
  readonly password: string
}

const SecurityChecklist: React.FC<SecurityChecklistProps> = (props) => {
  const { password } = props

  const items = [
    { key: 'minLength', label: 'At least 8 characters', valid: password.length >= PASSWORD_MIN_LENGTH_SIGN_UP },
  ]

  return (
    <ul className="SecurityChecklist">
      {items.map(item => {
        const itemClassName = item.valid
          ? 'SecurityChecklist__item SecurityChecklist__item--valid'
          : 'SecurityChecklist__item'
        return (
          <li key={item.key} className={itemClassName}>
            <span className="SecurityChecklist__icon">
              {item.valid ? <CheckValidIcon /> : <CheckMutedIcon />}
            </span>
            {item.label}
          </li>
        )
      })}
    </ul>
  )
}

export default SecurityChecklist
